/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListMarketingDataViewModel } from '../../models/list-marketing-data-view-model';

export interface GetAllMarketingDataByMerchant$Params {
  merchantId: string;
}

export function getAllMarketingDataByMerchant(http: HttpClient, rootUrl: string, params: GetAllMarketingDataByMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<ListMarketingDataViewModel>> {
  const rb = new RequestBuilder(rootUrl, getAllMarketingDataByMerchant.PATH, 'get');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ListMarketingDataViewModel>;
    })
  );
}

getAllMarketingDataByMerchant.PATH = '/merchants/{merchantId}/marketing-data';
